import FieldProto from "../../../proto/field-proto"
import FieldConfig from "../../../proto/field-config"
import {GROUP_INFO} from "../../../../gd/const/fields/field2-groups"
import {ConditionType_StatusChanged} from "../../../../model2/conditions/condition-types"
import FieldTaskStatusChanged_ConditionForm from "./render/condition"

// Condition-only field: filters tasks by the FACT of a status change recorded in
// task_message (from -> to within a date range), not by the current status.
// It has no table / edit / view rendering - it only appears in condition forms
// (dashboard widgets and custom views).

export default class FieldTaskStatusChanged extends FieldProto {

    constructor(config: FieldConfig) {
        super(config)

        this.conditionTypes = [ConditionType_StatusChanged]
        this.conditionFullWidth = true   // stacked layout: field on its own line, from/to + date below

        this.typeLabel          = "Status changed"
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Task status change (from / to over a period)"

        this.icon               = 'i5-statuses'

        this.renderComponents.conditionForm = FieldTaskStatusChanged_ConditionForm
    }

    // systemFieldId resolves to "task.updated_status" via the default
    // entityPrefix('task') + '.' + fieldId('updated_status'), matching the backend
    // const TASK_UPDATED_STATUS. No override needed: the fieldId is a single dot-free
    // segment, so GlobalFields.getBySystemFieldId (split '.', lookup by parts[1]) resolves it.
}
